document.addEventListener("DOMContentLoaded", () => {

  document.querySelectorAll(".product-item").forEach((card) => {

    const primaryImage = card.querySelector(".product-item__primary-image");

    if (!primaryImage) return;

    const radios = card.querySelectorAll(".color-swatch__radio");

    radios.forEach((radio) => {

      const updateCard = () => {

        if (radio.dataset.imageUrl) {

          primaryImage.style.opacity = "0";

          const img = new Image();

          img.onload = () => {

            primaryImage.src = radio.dataset.imageUrl;

            if (radio.dataset.mediaId) {
              primaryImage.dataset.mediaId = radio.dataset.mediaId;
            }

            if (radio.dataset.imageAspectRatio) {

              const wrapper = primaryImage.closest(".aspect-ratio");

              if (wrapper) {
                wrapper.style.paddingBottom =
                  (100 / parseFloat(radio.dataset.imageAspectRatio)) + "%";
              }
            }

            primaryImage.style.opacity = "1";

          };

          img.src = radio.dataset.imageUrl;
        }

        const productLink = card.querySelector(".product-item__title");

        if (productLink && radio.dataset.variantUrl) {
          productLink.href = radio.dataset.variantUrl;
        }

        const imageLink = card.querySelector(".product-item__image-wrapper");

        if (imageLink && radio.dataset.variantUrl) {
          imageLink.href = radio.dataset.variantUrl;
        }

        const variantInput =
          card.querySelector('input[name="id"]');

        if (variantInput && radio.dataset.variantId) {
          variantInput.value = radio.dataset.variantId;
        }

      };

      radio.addEventListener("mouseenter", updateCard);

      radio.addEventListener("change", updateCard);

    });

  });

});